// extracted by mini-css-extract-plugin
export default {"filter":"filter§IHcYOp0fzTbmGgyEBJ7o filterWrap§xMODGA1njxTgVyYDq2ma"};